import { render, staticRenderFns } from "./productBatchModal.vue?vue&type=template&id=1c49f668&scoped=true"
import script from "./productBatchModal.vue?vue&type=script&lang=js"
export * from "./productBatchModal.vue?vue&type=script&lang=js"
import style0 from "./productBatchModal.vue?vue&type=style&index=0&id=1c49f668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49f668",
  null
  
)

export default component.exports